/* Info Component in SeriesPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`px-3 py-2 ${styles.SubTitle6 }`} md={{span: 8, offset: 2 }}>
            <h5 className={`text-center pb-2 ${styles.Red }`} >2ND UNIT INFO</h5> 
            <hr className={`mt-2 mb-0`}/>
            <p className='mt-2'><span className={`${styles.Red}`}>*</span> The 2nd Unit section contains the 
            2nd Unit <span className={`${styles.Red}`}>Crew Info, 
            Schedule and Callsheets</span>, all of which are separate from the Main Unit.
           </p>
           <p className='mt-2'><span className={`${styles.Red}`}>*</span> If there are <span className={`${styles.Red}`}>multiple</span> 2nd Units, including an Aerial or 
            Marine Unit, all crew members are to be added to the Crew Info section using the "Position" 
            field to reference which Unit they belong to.
           </p>
           <p className='mt-2'><span className={`${styles.Red}`}>*</span> The 2nd Unit Schedule and its related Callsheets are intended 
            for the <span className={`${styles.Red}`}>Primary 2nd Unit</span> for any given Shoot Day.
           </p>
           <p className='mt-2'><span className={`${styles.Red}`}>*</span> A Shoot Day's addition Units' Schedules and Callsheets are to be handled 
            separatly.
           </p>
           <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info